import React, { useState, useContext } from 'react';
import { Title, Page, Input, Button, AuthContext } from '../shared';
import { ReactComponent as RequestResetPasswordSVG } from '../images/RequestResetPassword.svg';
import { Controller, useForm } from 'react-hook-form';
import axios from '../axios';
import styles from './RequestResetPassword.module.scss';
import { toast } from 'react-toastify';
import { ReactComponent as BeeHeroLogo } from '../images/BeeHeroLogo.svg';
import PuffLoader from 'react-spinners/PuffLoader';
import { emailIsRequiredText, emailKey, emailLabelText, enterEmailText, SERVICE_STATE, ADMIN_API } from '../shared/consts';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import { passwordSubtitleText, requestResetTitleText } from './textConsts';

const schema = yup
    .object({
        [emailKey]: yup.string().email().required(emailIsRequiredText)
    })
    .required();

const RequestResetPassword = ({ history }) => {
    const {
        formState: { errors, isValid },
        control,
        register,
        handleSubmit
    } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange'
    });
    const [isLoading, setIsLoading] = useState(false);
    const { serviceState } = useContext(AuthContext);

    const handleEmail = (data) => {
        setIsLoading(true);
        axios
            .post(`${ADMIN_API}/reset_password_request`, { email: data.email })
            .then((res) => {
                setIsLoading(false);
                if (res.status === 200) {
                    history.push('/email_sent');
                }
            })
            .catch((err) => {
                if (serviceState === SERVICE_STATE.OK) {
                    setIsLoading(false);
                    toast.error(err.response.data.message);
                }
            });
    };

    return (
        <Page>
            <BeeHeroLogo width={141} className={styles['page-beehero-logo']} />
            <form className={styles.form} onSubmit={handleSubmit(handleEmail)}>
                <Page.Section>
                    <Title
                        svg={RequestResetPasswordSVG}
                        title={requestResetTitleText}
                        subtitle={passwordSubtitleText}
                        iconSize={97}
                    />
                    <Controller
                        control={control}
                        name={emailKey}
                        render={({ field: { onChange, value } }) => (
                            <Input
                                type="text"
                                id={emailKey}
                                label={emailLabelText}
                                errors={errors?.[emailKey]}
                                onChange={onChange}
                                placeholder={enterEmailText}
                                register={register(emailKey).ref}
                                value={value}
                            />
                        )}
                    />
                </Page.Section>
                <Page.Section center>
                    <Button
                        float
                        color="margin-yellow"
                        type="submit"
                        className={styles.margin_button}
                        disabled={!isValid || isLoading}
                    >
                        Submit
                    </Button>
                </Page.Section>
            </form>
            {isLoading && (
                <div className={styles.loader_container}>
                    <PuffLoader color={'#ffcc2e'} size={150} />
                </div>
            )}
        </Page>
    );
};

RequestResetPassword.propTypes = {
    history: PropTypes.object
};
export default RequestResetPassword;
